export default __webpack_public_path__ + "static/media/5.2e7146d3.png";